import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { isAdminUser } from "../utils/roleUtils";
import { getUiChildren } from "../utils/uiConfig";
import { getUiIcon } from "../utils/uiIcons";
import "./HRToolsHome.css";

function HRToolsHome() {
  const navigate = useNavigate();
  const { user, uiConfig } = useContext(AuthContext);
  const isAdmin = isAdminUser(user);

  const tools = useMemo(
    () =>
      getUiChildren(uiConfig, "hr-tools", { isAdmin }).map((item) => ({
        ...item,
        Icon: getUiIcon(item.icon),
      })),
    [isAdmin, uiConfig]
  );

  return (
    <div className="hr-tools-wrapper">
      <div className="hr-tools-header">
        <h2 className="hr-title-main">HR Tools</h2>
      </div>

      <div className="hr-tools-container">
        {tools.map((tool) => {
          const Icon = tool.Icon;
          return (
            <div
              key={tool.id}
              className="hr-tool-card"
              onClick={() => navigate(tool.route)}
              style={{ "--accent-color": tool.accentColor || "#8b5cf6" }}
            >
              <div className="hr-icon-box">
                <Icon />
              </div>
              <div className="hr-card-content">
                <h3 className="hr-tool-name">{tool.label}</h3>
                <p className="hr-tool-desc">{tool.description}</p>
              </div>
              <div className="hr-card-arrow">-></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default HRToolsHome;
